import React from 'react';
import {Text} from '@mantine/core';

const AccessDenied = () => {
    return (
        <div
            style={{
                textAlign: 'center',
                marginTop: '30%',
                width: '100%',
                height: window.innerHeight * 0.9
            }}
        >
            <Text c="red" fw={700}>Sorry, you don't have access to this resource.</Text>
            <Text>Please contact your system administrator to request access.</Text>
        </div>
    );
};

export default AccessDenied;
